import * as React from "react"
const SvgDeviceMobile = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 23.571q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 21.57v-18q0-.824.588-1.412A1.93 1.93 0 0 1 7 1.57h10q.824 0 1.413.588Q19 2.745 19 3.57v18a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 17 23.57H7Zm0-3v1h10v-1zm0-2h10v-12H7zm0-14h10v-1H7z" />
  </svg>
)
export default SvgDeviceMobile
